import { JoinContext, JoinInitialValue, joinLocalRemove } from "../components/shared/JoinContext";
import { PATH, request } from "../components/shared/Api";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import AlertModal from "../components/ui/modal/AlertModal";
import Loading from "../components/active/Loading";

const AppleLogin = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isAlert, setIsAlert] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [login_false, set_login_false] = useState(false);
  const { setJoinProps } = useContext(JoinContext);
  const navigate = useNavigate();

  const Login = async () => {
    try {
      let redirect_uri = "https://cas.shcommunication.co.kr/login/applelogin";

      if (window.location.origin === "https://casappdev.shcommunication.co.kr") {
        redirect_uri = "https://casdev.shcommunication.co.kr/login/applelogin"; // Service IDs 생성할 때 등록한 Return URLs
      }
      const response = await request(PATH.socialSignOn, {
        socialType: "apple",
        code: searchParams.get("code"),
        redirect_uri: redirect_uri,
      });

      if (response.data.code === "0000") {
        if (response.data.accessToken !== "") {
          window?.localStorage && window.localStorage.setItem("token", response.data.accessToken);
          navigate("/");
        } else {
          joinLocalRemove();
          setJoinProps({
            ...JoinInitialValue,
            userId: response.data.userInfo.email,
            receipEmail: response.data.userInfo.email,
            userMobileNo: response.data.userInfo.mobile,
            userNm: response.data.userInfo.name,
            social: "Y",
          });
          navigate("/terms");
        }
      } else {
        setIsAlert(true);
        setModalMsg("애플 로그인에 실패하였습니다.");
        set_login_false(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // console.log(searchParams.get("code"));
    if (searchParams.get("code")) {
      Login();
    } else {
      setIsAlert(true);
      setModalMsg("애플 로그인에 실패하였습니다.");
      set_login_false(true);
    }
  }, []);

  useEffect(() => {
    if (login_false && !isAlert) {
      navigate("/");
    }
  }, [login_false, isAlert]);

  return (
    <React.Fragment>
      {isAlert ? <AlertModal modalMsg={modalMsg} closeModal={setIsAlert} /> : <Loading />}
    </React.Fragment>
  );
};

export default AppleLogin;
